import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function STLuciaCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>St. Lucia Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Fast Offshore Incorporation in the Caribbean</h3>
                            <p className='page-paragraph'>
                                A <b> St. Lucia IBC</b> is one of the most popular offshore company types in the Caribbean. It offers <b> privacy, flexibility, and tax efficiency,</b> making it ideal for <b> international trade, asset holding, and digital ventures.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Fast Setup",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Confidential",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Tax Neutral",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Cost-Effective",
                                        icon: TiTick,
                                    },
                                ]}
                            />


                            <Button
                                text="Request a St. Lucia Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in St. Lucia?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Recognition",
                                    paragraph: "Respected Caribbean offshore center",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "0% tax on offshore-sourced income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy",
                                    paragraph: "Owners & directors are not publicly listed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexibility",
                                    paragraph: "No restrictions on activities outside St. Lucia",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Incorporation",
                                    paragraph: "Setup within days",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Key Features of St. Lucia IBC
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "100% foreign ownership allowed",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "No minimum capital required",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "At least <b>1 shareholder & 1 director</b> (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Corporate directors permitted",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Local registered office & agent required",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "No exchange controls on international transactions",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                        <h3 className='page-title'>
                            Benefits of St. Lucia Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "0% Corporate Tax on offshore income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No Reporting",
                                    paragraph: "No obligation to file annual returns or accounts",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality",
                                    paragraph: "Details of shareholders/directors kept private",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Versatile Use",
                                    paragraph: "Holding, trading, consulting, digital business",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low-Cost Entry",
                                    paragraph: "Lower incorporation fees vs EU jurisdictions",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "1 shareholder & 1 director",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No residency requirement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered agent & office mandatory",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "KYC documents",
                                    paragraph: "Passport, address proof, CV",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Decide on shareholders/directors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Company name clearance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Drafting",
                                    paragraph: "Memorandum & Articles of Association",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registrar Filing",
                                    paragraph: "Incorporation with St. Lucia’s registry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation issued",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Optional Services",
                                    paragraph: "Nominees, apostille, bank introductions",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–5 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From USD 1,800+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal",
                                    paragraph: "Registered office, agent, government fees",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of St. Lucia Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "International trading company",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding company for shares, assets, or IP",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "E-commerce & digital ventures",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting or advisory firm",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Wealth & estate planning",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Why Offshore Advisory?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Licensed offshore specialists with Caribbean partners",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast-track incorporations & compliance packs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Nominee, apostille, & banking services available",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "St. Lucia vs SVG vs Seychelles vs Belize",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Long-term renewal & compliance support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a fast and affordable offshore company?"
                        description="A <b>St. Lucia IBC</b> offers speed, privacy, and tax efficiency — perfect for holding, trading, and digital ventures."
                        buttonText="Book a St. Lucia Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default STLuciaCompanyFormation

const faqData = [
    {
        question: "Do St. Lucia IBCs pay tax?",
        content: [
            { type: "answer", text: "No — 0% tax on offshore-sourced income." },
        ],
    },
    {
        question: "Is there a minimum capital requirement?",
        content: [
            { type: "answer", text: "No — IBCs may be incorporated with zero paid-up capital." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — full foreign ownership is allowed." },
        ],
    },
    {
        question: "Is there annual reporting?",
        content: [
            { type: "answer", text: "No — IBCs are exempt from annual return filing." },
        ],
    },
    {
        question: "Can I open a bank account?",
        content: [
            { type: "answer", text: "Yes — usually in offshore-friendly jurisdictions like Mauritius, Seychelles, or Panama." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Our St. Lucia IBC gave us the flexibility we needed for our online trading business. Offshore Advisory handled everything in just a week.",
        author: "Victor R.",
        role: "Victor R., Entrepreneur",
    },
    {
        quote:
            "We wanted a Caribbean offshore company for asset holding. St. Lucia was fast and efficient thanks to Offshore Advisory.",
        author: "Elena S.",
        role: "Investor",
    },
];